import { render } from "./BlockTitle.vue?vue&type=template&id=469a90c0&scoped=true"
import script from "./BlockTitle.vue?vue&type=script&lang=js"
export * from "./BlockTitle.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-469a90c0"

export default script